import { computed } from '@angular/core';
import {
  patchState,
  signalStoreFeature,
  withComputed,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import {
  injectIsUserResourceActive,
  injectUserResource,
} from '../resources/user.resource';
import { Team, User } from '@seatix/shared-domain-auth';

export function withUserResource() {
  return signalStoreFeature(
    withState<{
      user: User | null;
      current_team: Team | null;
      sessionValidated: boolean;
      /**
       * clearUser() destroys the /me resource, and a destroyed resource never
       * loads again: its status can no longer tell "loading" from "never".
       */
      isUserResourceDestroyed: boolean;
    }>({
      user: null,
      current_team: null,
      sessionValidated: false,
      isUserResourceDestroyed: false,
    }),
    withProps(() => ({
      _userResource: injectUserResource(),
      _isResourceActive: injectIsUserResourceActive(),
    })),
    withProps(({ _userResource }) => ({
      userResource: _userResource.asReadonly(),
    })),
    withComputed(({ user }) => {
      const isEmailVerified = computed(() => !user()?.needs_email_verification);
      return {
        isEmailVerified,
      };
    }),
    withMethods((store) => ({
      setUser: function (user: User) {
        store._userResource.set(user);
        const firstTeam =
          user.teams && user.teams.length > 0 ? user.teams[0] : null;
        patchState(store, {
          user,
          current_team: firstTeam,
          sessionValidated: true,
        });
      },
      clearUser: function () {
        store._userResource.destroy();
        patchState(store, {
          user: undefined,
          current_team: null,
          sessionValidated: false,
          isUserResourceDestroyed: true,
        });
      },
      setCurrentTeam: function (team: Team) {
        patchState(store, {
          current_team: team,
        });
      },
      setResourceActive: function (isActive: boolean) {
        store._isResourceActive.set(isActive);
      },
      reloadUser: function () {
        store._userResource.reload();
      },
    })),
  );
}
